






import moment from 'moment'

export default {
  props: {
    validUntil: { type: String, required: true }
  },
  data() {
    return {
      interval: null,
      now: moment() as moment.Moment
    }
  },
  computed: {
    formattedTimeDifference(): string {
      const totalHours = this.timeDiffFromNow.days() * 24 + this.timeDiffFromNow.hours()
      const formattedHours = totalHours > 0 ? totalHours + 'h ' : ''
      return formattedHours + this.timeDiffFromNow.minutes() + 'm'
    },
    timeDiffFromNow(): moment.Duration {
      const localValidUntil = moment.utc(this.validUntil).local()
      return moment.duration(localValidUntil.diff(this.now))
    }
  },
  watch: {
    timeDiffFromNow(diff): void {
      if (diff.asMinutes() < 0) this.$emit('change-validity')
    }
  },
  created() {
    this.interval = setInterval(this.setNow, 60000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    setNow() {
      this.now = moment()
    }
  }
}
